/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import NavbarSearch from "./NavbarSearch";
import NavbarNotifications from "./NavbarNotifications";
import NavbarLogin from "./NavbarLogin";

class NavbarTop extends React.Component {
    static propTypes = {
        onClickMinimize: PropTypes.func,
        onLogout: PropTypes.func
    };
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
        this.onClickMinimize = this.onClickMinimize.bind(this);
    }

    onClickMinimize(e) {
        e.preventDefault();
        if (this.props.onClickMinimize) this.props.onClickMinimize();
    }

    // <span className="m-r-sm text-muted welcome-message">Ridango Authentication Module</span>

    render() {
        return (
            <nav className="navbar navbar-static-top" style={{marginBottom: "0"}}>
                <div className="navbar-header">
                    <a className="navbar-minimalize minimalize-styl-2 btn btn-primary" href="#" onClick={this.onClickMinimize}>
                        <i className="fa fa-bars"/>
                    </a>
                </div>
                <ul className="nav navbar-top-links navbar-left">
                    <NavbarSearch/>
                </ul>
                <ul className="nav navbar-top-links navbar-right">
                    <li>
                    </li>
                    <NavbarNotifications/>
                    <NavbarLogin onLogout={this.props.onLogout}/>
                </ul>
            </nav>
        );
    }
}

export default NavbarTop;
